import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from '../endpoints';
import { TextConfigurationItemWire } from './types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadText: async (textId: number, textSet: number): Promise<TextConfigurationItemWire> => {
    const response = await new RemoteAdminData(endpoints.text(textSet))
      .resource<ApiResponse<TextConfigurationItemWire>>()
      .withId(textId)
      .single();

    return response.data;
  },

  deleteText: (textId: number, textSet: number): Promise<void> => {
    return new RemoteAdminData(endpoints.text(textSet))
      .resource<void>()
      .withId(textId)
      .httpDelete({});
  },

  createText: async (text: TextConfigurationItemWire): Promise<number> => {

    const response: any = await new RemoteAdminData(endpoints.createText)
      .resource<ApiResponse<number>>()
      .create(text, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  saveText: async (textId: number, textSet: number, text: TextConfigurationItemWire): Promise<number> => {

    await new RemoteAdminData(endpoints.text(textSet))
      .resource<void>()
      .withId(textId)
      .save(text);

    return textId;
  }
};
